export const NERDWALLET_TOKEN_SERVICE_PATH = '/api/nts/v1/login';
